<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
  <div class="row unselectable headerTitle headline">{{translation.VehicleLogistics}}</div>
  <div class="breakLine"></div>
  <div id="moduleContent" class="row unselectable">
    <app-module *ngIf="logisticsTaskModule != null" class="cotraModuleCard col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin: auto"
                [module]="logisticsTaskModule" (click)="navigate(logisticsTaskModule.ForwardLink)"></app-module>
    <!-- remove custom style when there is more than one card -->
  </div>
</div>
<app-footer></app-footer>
